import { assetsPath } from "../../utils";

const landingPage = [
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/1.jpg`
  },
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/2.jpg`
  },
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/3.jpg`
  },
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/4.jpg`
  },
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/5.jpg`
  },
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/6.jpg`
  },
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/7.jpg`
  },
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/8.jpg`
  },
  {
    image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/9.jpg`
  },
];

const type = [
  {
    name: {
      en: '2 BEDROOM',
      ru: '2 СПАЛЬНИ',
      cn: '2间卧室',
    },
    // buttonImages: {
    //   default: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/2.jpg`,
    //   hover: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/5.jpg`
    // },
    thumbnail: [
      {
        image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/2.jpg`
      },
      {
        image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/5.jpg`
      },
    ],
    buttons: [
      {
        type: "description",
        value: 0,
        name: "Description",
        title: "2 Bedroom",
        description: {
          en:
            "<p>Spread out over three storeys, the two bedroom villas measure 334 sqm of well defined spaces anchored by a kitchen, dining area, and living room which opens out to a terrace. Making up the heart of the home on the second floor are the two bedrooms, each with ensuite bathrooms and private balcony. Crowning the villas is the entertainment level on the rooftop, 26 sqm pool and sun deck on one end, plus a party deck on the other,<br />fully equipped with a pantry and a BBQ area.</p>",
          cn:
            "<p>Spread out over three storeys, the two bedroom villas measure 334 sqm of well defined spaces anchored by a kitchen, dining area, and living room which opens out to a terrace. Making up the heart of the home on the second floor are the two bedrooms, each with ensuite bathrooms and private balcony. Crowning the villas is the entertainment level on the rooftop, 26 sqm pool and sun deck on one end, plus a party deck on the other,<br />fully equipped with a pantry and a BBQ area.</p>",
          ru:
            "<p>Spread out over three storeys, the two bedroom villas measure 334 sqm of well defined spaces anchored by a kitchen, dining area, and living room which opens out to a terrace. Making up the heart of the home on the second floor are the two bedrooms, each with ensuite bathrooms and private balcony. Crowning the villas is the entertainment level on the rooftop, 26 sqm pool and sun deck on one end, plus a party deck on the other,<br />fully equipped with a pantry and a BBQ area.</p>",
        },
        images: [
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/1.jpg`,
            backgroundPosition: '0% center'
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/2.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/3.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/4.jpg`
          }
        ]
      },
      {
        type: "plan",
        name: "GROUND FLOOR",
        value: 1,
        floorPlan: {
            en: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/ground-floor/floor-plan/image_en.png`,
            ru: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/ground-floor/floor-plan/image_ru.png`,
            cn: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/ground-floor/floor-plan/image_cn.png`
        },
        images: [
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/1.jpg`,
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/2.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/3.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/4.jpg`
          }
        ],
        image360: [
          {
            x: 940,
            y: 435,
            currentIndex: 2
          },
          {
            x: 930,
            y: 780,
            currentIndex: 3
          }
        ],
        imageVirtual: [
          {
            x: 990,
            y: 380,
            path: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/residence-two-bedroom/DS-Living.html`
          },
          {
            x: 990,
            y: 820,
            path: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/residence-two-bedroom/DS-Dining.html`
          }
        ]
      },
      {
        type: "plan",
        name: "1 st Floor",
        value: 2,
        floorPlan: {
            en: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/first-floor/floor-plan/image_en.png`,
            ru: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/first-floor/floor-plan/image_ru.png`,
            cn: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/first-floor/floor-plan/image_cn.png`
        },
        images: [
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/1.jpg`,
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/2.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/3.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/4.jpg`
          }
        ],
        image360: [
          {
            x: 926,
            y: 266,
            path: '/assets/images/residences/two-bedroom/description/2.jpg'
          },
          // {
          //   x: 900,
          //   y: 810,
          //   path: '/assets/images/residences/two-bedroom/description/3.jpg'
          // }
        ],
        imageVirtual: [
          {
            x: 970,
            y: 175,
            path: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/residence-two-bedroom/DS-MB.html`
          },
          {
            x: 970,
            y: 820,
            path: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/residence-two-bedroom/DS-BR2.html`
          }
        ]
      },
      {
        type: "plan",
        name: "2 nd Floor",
        value: 3,
        floorPlan: {
            en: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/second-floor/floor-plan/image_en.png`,
            ru: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/second-floor/floor-plan/image_ru.png`,
            cn: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/second-floor/floor-plan/image_cn.png`
        },
        images: [
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/1.jpg`,
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/2.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/3.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/two-bedroom/description/4.jpg`
          }
        ],
        image360: [],
        imageVirtual: [
          {
            x: 980,
            y: 330,
            path: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/residence-two-bedroom/DS-Pool.html`
          },
          {
            x: 895,
            y: 1020,
            path: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/360/residence-two-bedroom/DS-PD.html`
          }
        ]
      },
    ]
  },
  {
    name: {
      en: '3 BEDROOM',
      ru: '3 СПАЛЬНИ',
      cn: '3间卧室',
    },
    // buttonImages: {
    //   default: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/7.jpg`,
    //   hover: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/9.jpg`
    // },
    thumbnail: [
      {
        image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/7.jpg`
      },
      {
        image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/9.jpg`
      },
    ],
    buttons: [
      {
        type: "description",
        value: 0,
        name: "Description",
        title: "3 Bedroom",
        description: {
          en:
            "<p>Similar in layout to the two-bedroom villas, the 552 sqm three-bedroom villa features added space and an extra bedroom on the ground floor complete with a private outdoor patio. The dining area looks out over the open plan living room naturally lit by the garden courtyard. Both bedrooms on the second floor come with ensuite bathrooms and private terraces; the master bedroom also includes a large walk-in closet, a wraparound balcony, and a large bathroom. Up on the rooftop, a lush vertical garden near the BBQ and dining area emphasizes the beauty of the villas’ natural surroundings, while a 45 sqm private pool and large sun deck make up the focal point for al fresco dinners and parties.</p>",
          cn:
            "<p>Similar in layout to the two-bedroom villas, the 552 sqm three-bedroom villa features added space and an extra bedroom on the ground floor complete with a private outdoor patio. The dining area looks out over the open plan living room naturally lit by the garden courtyard. Both bedrooms on the second floor come with ensuite bathrooms and private terraces; the master bedroom also includes a large walk-in closet, a wraparound balcony, and a large bathroom. Up on the rooftop, a lush vertical garden near the BBQ and dining area emphasizes the beauty of the villas’ natural surroundings, while a 45 sqm private pool and large sun deck make up the focal point for al fresco dinners and parties.</p>",
          ru:
            "<p>Similar in layout to the two-bedroom villas, the 552 sqm three-bedroom villa features added space and an extra bedroom on the ground floor complete with a private outdoor patio. The dining area looks out over the open plan living room naturally lit by the garden courtyard. Both bedrooms on the second floor come with ensuite bathrooms and private terraces; the master bedroom also includes a large walk-in closet, a wraparound balcony, and a large bathroom. Up on the rooftop, a lush vertical garden near the BBQ and dining area emphasizes the beauty of the villas’ natural surroundings, while a 45 sqm private pool and large sun deck make up the focal point for al fresco dinners and parties.</p>",
        },
        images: [
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/description/1.jpg`,
            backgroundPosition: 'bottom center'
          },
        ]
      },
      {
        type: "plan",
        name: "GROUND FLOOR",
        value: 1,
        floorPlan: {
            en: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/floor-plan/image_en.png`,
            ru: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/floor-plan/image_ru.png`,
            cn: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/floor-plan/image_cn.png`,
        },
        images: [
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/images/1.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/images/2.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/images/3.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/images/4.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/images/5.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/images/6.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/images/7.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/ground-floor/images/8.jpg`
          }
        ],
        image360: [],
        imageVirtual: []
      },
      {
        type: "plan",
        name: "1 st Floor",
        value: 2,
        floorPlan: {
            en: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/floor-plan/image_en.png`,
            ru: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/floor-plan/image_ru.png`,
            cn: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/floor-plan/image_cn.png`
        },
        images: [
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/images/1.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/images/2.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/images/3.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/images/4.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/images/5.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/images/6.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/images/7.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/first-floor/images/8.jpg`
          }
        ],
        image360: [],
        imageVirtual: []
      },
      {
        type: "plan",
        name: "2 nd Floor",
        value: 3,
        floorPlan: {
            en: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/second-floor/floor-plan/image_en.png`,
            ru: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/second-floor/floor-plan/image_ru.png`,
            cn: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/second-floor/floor-plan/image_cn.png`,
        },
        images: [
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/second-floor/images/1.jpg`
          },
          {
            image: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/three-bedroom/second-floor/images/2.jpg`
          },
        ],
        image360: [],
        imageVirtual: []
      },
    ]
  },
];

export default {
  landingPage,
  type
};



// WEBPACK FOOTER //
// ./src/data/PhuketDusitDeluxePoolVilla/residence.js